export enum LOYALTY_POINT_TYPE {
  SHARE = 'share',
  MY_CLUB = 'myclub',
}
